import { Backdrop, CircularProgress, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import { NewCommentProps } from './props';
import { useStyles as useStylesGeneral } from '../styles';
const useStyles = makeStyles({
  root: {
    position: 'relative',
  },
  textarea: {
    width: '100%',
  },
  publish: {},
  title: {
    fontSize: 14,
  },
  backdrop: {
    position: 'absolute',
    zIndex: 2,
    color: '#fff',
  },
});

export function NewComment({
  loading,
  autoloading,
  onSubmit,
}: NewCommentProps) {
  const classes = useStyles();
  const classesGeneral = useStylesGeneral();
  const [content, setContent] = useState('');
  const [innerLoading, setInnerLoading] = useState(false);
  const onSubmitHandler = async () => {
    autoloading && setInnerLoading(true);
    if (onSubmit) {
      try {
        if (await onSubmit(content)) {
          setContent('');
        }
      } finally {
      }
    }
    autoloading && setInnerLoading(false);
  };
  return (
    <Card
      variant='outlined'
      className={`${classes.root} ${classesGeneral.cardbox}`}
    >
      <CardContent>
        <TextField
          value={content}
          onChange={(a) => setContent(a.target.value)}
          className={classes.textarea}
          id='outlined-multiline-static'
          label='¿Alguna novedad que comentar?'
          multiline
          minRows={4}
          maxRows={4}
          variant='outlined'
        />
        <Button size='small' color='primary' onClick={onSubmitHandler}>
          Publicar
        </Button>
        {loading ||
          (innerLoading && (
            <Backdrop className={classes.backdrop} open={true}>
              <CircularProgress color='inherit' />
            </Backdrop>
          ))}
      </CardContent>
    </Card>
  );
}
